import { render, staticRenderFns } from "./RemoveReward.vue?vue&type=template&id=0f76a000&scoped=true&"
import script from "./RemoveReward.vue?vue&type=script&lang=js&"
export * from "./RemoveReward.vue?vue&type=script&lang=js&"
import style0 from "./RemoveReward.vue?vue&type=style&index=0&id=0f76a000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f76a000",
  null
  
)

export default component.exports